import useGetKeyByActivity from '../providers/ActivityKeyer/useGetKeyByActivity';

export default useGetKeyByActivity;
